import { Button } from "react-bootstrap"

import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import { ScheduleStatus } from "../../config/Constants"

interface FormFoxTestANColumnProps {
  row: OrderResultRecord
  showAuthFormModal: (row: OrderResultRecord) => void
}

function FormFoxTestANColumn(props: FormFoxTestANColumnProps) {
  const { row, showAuthFormModal } = props

  const isLinkVisible =
    row.FormFoxTestAN !== "" &&
    !row.DateCollected &&
    row.ScheduleStatusID !== ScheduleStatus.Cancelled &&
    !row.IsExpired

  return isLinkVisible ? (
    <Button variant="underline-link pl-1" onClick={() => showAuthFormModal(row)}>
      {row.FormFoxTestAN}
    </Button>
  ) : (
    <div className="text-nowrap ml-1">{row.FormFoxTestAN}</div>
  )
}

export default FormFoxTestANColumn
